module.exports = __webpack_public_path__ + "cff8ecc785fbf4c521ad186d336eca11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chloe/stamps/17_CC_V_Sleigh.png
// module id = 118
// module chunks = 0